// auth.guard.ts
import { isPlatformBrowser } from '@angular/common';
import { CanActivateFn, ActivatedRouteSnapshot } from '@angular/router';
import { PLATFORM_ID, inject } from '@angular/core';
import { Router } from '@angular/router';

import { readStorage } from '../utils/storage';
import { holdsSystemRole } from '../services/permission.service';

/**
 * Requires sign-in and one of the route's System Roles, or a higher one (a route listing ROLE_ADMIN admits
 * ROLE_SYS_ADMIN). On the server render it defers to the browser, which re-runs it (localStorage only exists
 * there). Refusing on the server keeps protected pages out of the server render. Campaign Roles are checked by
 * campaignRoleGuard.
 */
export const authGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  if (!isPlatformBrowser(inject(PLATFORM_ID))) {
    return false;
  }
  const router = inject(Router);
  const token = readStorage('authToken');
  const userRoles = readStorage('roles')?.split(',') ?? [];

  // Roles allowed from route data; no list means any signed-in user.
  const allowedRoles = (route.data?.['roles'] as string[] | undefined) ?? [];

  if (!token) {
    router.navigateByUrl('/auth/login');
    return false;
  } else if (allowedRoles.length === 0 || allowedRoles.some(role => holdsSystemRole(userRoles, role))) {
    return true;
  }

  router.navigateByUrl('/auth/denied');
  return false;
};
